import { TokenService } from "./TokenService";

/**
 * Thin wrapper around fetch() for Supabase edge function calls that:
 * 1. Injects fresh Authorization + apikey headers
 * 2. Auto-retries once on 401 with a force-refreshed token
 */
export async function fetchWithAuth(
  url: string,
  options: RequestInit = {},
): Promise<Response> {
  const token = await TokenService.getAccessToken();

  const res = await fetch(url, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
      ...(options.headers as Record<string, string>),
    },
  });

  // One-shot retry on 401 with force-refreshed token
  if (res.status === 401) {
    const freshToken = await TokenService.getAccessToken(true);
    if (!freshToken) return res; // can't refresh — return original 401

    return fetch(url, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${freshToken}`,
        apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
        ...(options.headers as Record<string, string>),
      },
    });
  }

  return res;
}
